import React, {useEffect, useState, useRef, useContext} from "react";
import {store} from '../context/store';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4plugins_sunburst from "@amcharts/amcharts4/plugins/sunburst";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";


import {LICENCE_KEY} from "../constants/charts";


am4core.useTheme(am4themes_animated);

am4core.addLicense(LICENCE_KEY);

export default function AmChartSunburst({chartId, width, height, chartData, valueColumn, nameColumn, childrenColumn}){
	
	
	const chart = useRef(null);
	const globalState = useContext(store);
	
	
	function mapSunburstData(rows)
	{
	    const returnValues = [];

	    if(!rows)
	    {
	        return returnValues;
	    }

	    for(let i = 0; i < rows.length; i++)
	    {
	        returnValues.push(
	            mapSunburstNode(
	                rows[i]
	            )
	        );
	    }

	    return returnValues;
	}

	function mapSunburstNode(row)
	{
	    const returnValue =
	    {
	        name:
	            row[nameColumn],

	        value:
	            row[valueColumn]
	    };

	    const sourceChildren =
	        row[childrenColumn];

	    if(
	        sourceChildren &&
	        sourceChildren.length > 0
	    )
	    {
	        returnValue.children = [];

	        for(let i = 0; i < sourceChildren.length; i++)
	        {
	            returnValue.children.push(
	                mapSunburstNode(
	                    sourceChildren[i]
	                )
	            );
	        }
	    }

	    return returnValue;
	}
	
	if(
	    !chartData ||
	    chartData.length === 0
	)
	{
	    return null;
	}
	
	const mappedChartData =
	    mapSunburstData(
	        chartData
	    );
	
	useEffect(() => {
			
			
		}, [chartData]);
		

	useEffect(() => {
		let x = am4core.create(chartId, am4plugins_sunburst.Sunburst);
		
		
		x.padding(0,0,0,0);
		x.radius = am4core.percent(98);

		x.colors.step = 2;
		x.fontSize = 11;
		x.innerRadius = am4core.percent(10);

		// define data fields
		x.dataFields.value = "value";
		x.dataFields.name = "name";
		x.dataFields.children = "children";
		
		x.data = mappedChartData;
		
		var level0SeriesTemplate = new am4plugins_sunburst.SunburstSeries();
		level0SeriesTemplate.hiddenInLegend = false;
		x.seriesTemplates.setKey("0", level0SeriesTemplate)
		
		
		// this makes labels to be hidden if they don't fit
		level0SeriesTemplate.labels.template.truncate = true;
		level0SeriesTemplate.labels.template.hideOversized = true;
		
		level0SeriesTemplate.labels.template.adapter.add("rotation", function(rotation, target) {
		  target.maxWidth = target.dataItem.slice.radius - target.dataItem.slice.innerRadius - 10;
		  target.maxHeight = Math.abs(target.dataItem.slice.arc * (target.dataItem.slice.innerRadius + target.dataItem.slice.radius) / 2 * am4core.math.RADIANS);
		
		  return rotation;
		})
		
		
		var level1SeriesTemplate = level0SeriesTemplate.clone();
		x.seriesTemplates.setKey("1", level1SeriesTemplate)
		level1SeriesTemplate.fillOpacity = 0.75;
		level1SeriesTemplate.hiddenInLegend = true;
		
		var level2SeriesTemplate = level0SeriesTemplate.clone();
		x.seriesTemplates.setKey("2", level2SeriesTemplate)
		level2SeriesTemplate.fillOpacity = 0.5;
		level2SeriesTemplate.hiddenInLegend = true;
		
		//x.legend = new am4charts.Legend();
		
		chart.current = x;
		
		
		
		return () => {
			x.dispose();
			if(x.legend){
				x.legend.dispose();
			}
		};
		
	}, [chartId, chartData]);
	
	
	
		
	return (
			<div id={chartId} style={{ width: width, height:height}}></div>

	);
}